// extracted by mini-css-extract-plugin
export default {"holdertitle":"CardHolder_holdertitle__Xuud5","cardholder":"CardHolder_cardholder__CLyoD","cards":"CardHolder_cards__kpKFo"};